import { createContext, useContext, useEffect, useState } from 'react';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';

const AuthContext = createContext({ isAuthenticated: false, isChecking: true });

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isChecking, setIsChecking] = useState(true);

    useEffect(() => {
        const checkSession = async () => {
            setIsChecking(true);
            try {
                await fetchAuthSession();
                const { username } = await getCurrentUser(); 

                const allowedUsername = "a99e9458-a031-70c8-c233-77805d0dfe46"; 

                if (username === allowedUsername) {
                    setIsAuthenticated(true);
                } else {
                    console.error('Access denied: Incorrect username');
                    setIsAuthenticated(false);
                }
            } catch (error) {
                console.error('Session check failed:', error);
                setIsAuthenticated(false);
            }
            setIsChecking(false);
        };

        checkSession();
    }, []);

    return (
        <AuthContext.Provider value={{ isAuthenticated, isChecking }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);






